import dwvVue from './dwv'

export default {
  dwvVue,
}